import { Tutorial } from '../tutorial.model';

/** Percorre os controles e cada bloco real do painel, inclusive sem movimentações. */
export const DASHBOARD_TOUR: Tutorial = {
  id: 'dashboard',
  rota: '/painel/dashboard',
  passos: [
    {
      alvo: 'dashboard.filtros', fase: 'Filtros e período',
      titulo: 'Escolha o que deseja acompanhar',
      corpo: 'Filtrar abre a gaveta com período, centro de custo, categorias e caixas excluídos do fluxo. Marcar categorias restringe a análise às escolhidas; deixar vazio inclui todas. O número ao lado de Filtrar indica os filtros adicionais ativos.',
      posicao: 'abaixo',
    },
    {
      alvo: 'dashboard.periodo', fase: 'Filtros e período',
      titulo: 'Confira o período da análise',
      corpo: 'Este botão mostra o período selecionado e também abre os filtros para trocá-lo. Os indicadores e o histórico usam esse recorte. Na Agenda financeira, Hoje e Próximos 7 dias continuam mostrando os vencimentos dessas janelas.',
      posicao: 'abaixo',
    },
    {
      alvo: 'dashboard.ocultar-valores', fase: 'Filtros e período',
      titulo: 'Oculte os valores quando precisar',
      corpo: 'Use Ocultar valores ao compartilhar a tela ou trabalhar perto de outras pessoas. O botão passa a Mostrar valores para exibi-los novamente. Essa escolha muda a visualização, sem alterar os registros.',
      posicao: 'abaixo',
    },
    {
      alvo: 'dashboard.indicadores', fase: 'Indicadores do período',
      titulo: 'Resultado: acompanhe a diferença entre recebido e pago',
      corpo: 'O resultado reúne recebimentos menos despesas pagas das contas com vencimento no período. A linha mostra a evolução e, quando disponível, a indicação ao lado compara com o período anterior. O saldo disponível nos bancos aparece em Caixas e cartões.',
      posicao: 'abaixo',
    },
    {
      alvo: 'dashboard.recebimentos', fase: 'Indicadores do período',
      titulo: 'Recebimentos: veja quanto entrou',
      corpo: 'Este cartão mostra o valor recebido das contas com vencimento no período escolhido. Clique nele para abrir as contas a receber nesse mesmo recorte. Cadastrar uma receita e registrar seu recebimento são etapas diferentes: a baixa alimenta este indicador.',
      posicao: 'abaixo',
    },
    {
      alvo: 'dashboard.despesas', fase: 'Indicadores do período',
      titulo: 'Despesas: acompanhe o que foi pago',
      corpo: 'Aqui aparece o valor pago das contas com vencimento no período. Clique no cartão para abrir as contas a pagar desse recorte. Registre as baixas conforme os pagamentos realizados para manter o indicador atualizado.',
      posicao: 'abaixo',
    },
    {
      alvo: 'dashboard.margem', fase: 'Indicadores do período',
      titulo: 'Margem: leia o resultado em percentual',
      corpo: 'A margem mostra quanto o resultado representa sobre os recebimentos do período. Use-a junto dos valores de receitas e despesas para acompanhar a evolução. Quando ainda não há recebimentos, falta uma base para avaliar essa proporção.',
      posicao: 'abaixo',
    },
    {
      alvo: 'dashboard.agenda', fase: 'Agenda, gráficos e saldos',
      titulo: 'Agenda: organize os próximos pagamentos e recebimentos',
      corpo: 'Consulte o saldo em caixas, o que vence hoje, os próximos 7 dias e os recebimentos em atraso. Clique nos valores para abrir os caixas ou as contas correspondentes. Cadastre os vencimentos para começar a enxergar sua rotina aqui.',
      posicao: 'direita',
    },
    {
      alvo: 'dashboard.fluxo-de-caixa', fase: 'Agenda, gráficos e saldos',
      titulo: 'Fluxo de caixa: antecipe a necessidade de dinheiro',
      corpo: 'Ideal considera os recebimentos e pagamentos previstos; Pior considera os pagamentos sem novos recebimentos. Compare as curvas e deslize para consultar os demais dias. Os vencimentos das contas alimentam essa previsão, que ajuda a perceber uma falta de caixa com antecedência.',
      posicao: 'acima',
    },
    {
      alvo: 'dashboard.historico', fase: 'Agenda, gráficos e saldos',
      titulo: 'Compare receita, despesa e resultado ao longo do tempo',
      corpo: 'O histórico reúne as três séries para comparar os períodos. Use o controle 6/12 para ampliar a janela e deslize o gráfico quando necessário. Ele segue o recorte do painel e agrupa as contas pela data de vencimento.',
      posicao: 'acima',
    },
    {
      alvo: 'dashboard.inadimplencia', fase: 'Agenda, gráficos e saldos',
      titulo: 'Inadimplência: identifique os atrasos do período',
      corpo: 'Confira os valores e a quantidade de contas em atraso, separados entre receber e pagar. O percentual compara o atraso com o valor previsto no período. Clique na linha para abrir as contas correspondentes e tratar o que está pendente.',
      posicao: 'direita',
    },
    {
      alvo: 'dashboard.caixas', fase: 'Agenda, gráficos e saldos',
      titulo: 'Caixas e cartões: acompanhe os saldos',
      corpo: 'Veja o saldo de cada caixa ou conta bancária e o total em caixas. Quando houver mais contas, use as setas para percorrê-las; Ver caixas abre a lista de caixas. A aba de cartões aparece quando disponível. O saldo inicial e as movimentações registradas alimentam esta visão.',
      posicao: 'acima',
    },
    {
      alvo: 'dashboard.categorias', fase: 'Agenda, gráficos e saldos',
      titulo: 'Categorias: entenda de onde vem e para onde vai o dinheiro',
      corpo: 'Alterne entre Receita e Despesa para ver a distribuição dos valores baixados. A tabela mostra valor e participação; passar o cursor sobre uma linha destaca sua fatia. Sem movimentações, essa visão será preenchida pelas primeiras contas e baixas. Volte ao roteiro para preparar os cadastros e começar.', corpoManual: 'Alterne entre Receita e Despesa para ver a distribuição dos valores baixados. A tabela mostra valor e participação; passar o cursor sobre uma linha destaca sua fatia. Sem movimentações, essa visão será preenchida pelas primeiras contas e baixas.',
      posicao: 'acima',
    },
  ],
};
